export default function ValuesSection() {
  const values = [
    {
      title: 'Clean Architecture',
      description:
        'Structured, modular codebases designed for long-term maintainability and seamless collaboration across engineering disciplines.',
      bgFrom: '#e8d5d0',
      bgTo: '#dcc8c1',
    },
    {
      title: 'Performance First',
      description:
        'Every system is profiled, measured, and continuously optimized to deliver responsive and resource-efficient experiences.',
      bgFrom: '#cdd9cc',
      bgTo: '#bcc8b9',
    },
    {
      title: 'User-Centered Design',
      description:
        'Decisions grounded in usability research and real interaction patterns, ensuring intuitive and accessible interfaces.',
      bgFrom: '#d9d5cd',
      bgTo: '#cbc7be',
    },
    {
      title: 'Continuous Innovation',
      description:
        'Ongoing exploration of emerging technologies and refinement of internal processes to sustain technical excellence over time.',
      bgFrom: '#dbcfb8',
      bgTo: '#cec2a8',
    },
  ];

  return (
    <section className="relative py-28 md:py-36 px-4 md:px-8 bg-background-200/70">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-16 md:mb-20 gap-6">
          <div>
            <p className="text-xs tracking-[0.2em] uppercase text-foreground-500 font-medium mb-4">
              Engineering Principles
            </p>
            <h2 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold leading-[1.15] tracking-tight text-foreground-950">
              How We
              <br />
              <span className="italic font-light opacity-80">Operate</span>
            </h2>
          </div>
          <div className="flex gap-2">
            <span className="w-2 h-2 rounded-full bg-foreground-300" />
            <span className="w-2 h-2 rounded-full bg-foreground-200" />
            <span className="w-2 h-2 rounded-full bg-foreground-400" />
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {values.map((value) => (
            <div
              key={value.title}
              className="rounded-[24px] overflow-hidden flex flex-col"
            >
              <div
                className="h-[260px] md:h-[300px] relative flex items-center justify-center"
                style={{
                  background: `linear-gradient(160deg, ${value.bgFrom} 0%, ${value.bgTo} 100%)`,
                }}
              >
                <div
                  className="absolute inset-0 opacity-20"
                  style={{
                    backgroundImage:
                      'radial-gradient(circle at 60% 40%, rgba(255,255,255,0.4) 0%, transparent 60%)',
                  }}
                />
                <div
                  className="absolute inset-0 opacity-15"
                  style={{
                    backgroundImage:
                      'repeating-linear-gradient(0deg, transparent, transparent 3px, rgba(0,0,0,0.03) 3px, rgba(0,0,0,0.03) 3.5px)',
                  }}
                />
              </div>
              <div className="bg-background-50 px-6 py-7 flex-1">
                <h3 className="font-heading text-base font-semibold text-foreground-950 mb-2">
                  {value.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {value.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}